/**
 * Der Tieflink auf eine Bestellung - die reine Pfadbildung, aus `state/adresse.ts#schreiben` gezogen (KI-Zugang, Stufe 1),
 * damit der Server (Werkzeuge `bestellung_details`, `search`, `fetch`) mit DEMSELBEN Quelltext den Link baut wie die
 * Adresszeile der Oberflaeche. Keine Aenderung am Format: `/bestellung/<kennung>` mit der Kennung als Pfadsegment
 * (`encodeURIComponent`), Spezifikation `2026-08-25-tieflinks-adresszeile-design.md` § 3.1 und § 3.5.
 *
 * `bestellungPfadTeile` ist die Stelle, die `schreiben` ruft (die Teile `bestellung` und `<kennung>` hinter dem Seitenkuerzel);
 * `bestellungKurzlink` ist die Kurzform ohne Seite (§ 3.5): sie behauptet bewusst KEINE Seite, damit ein verschickter Link nicht am
 * Seitenrecht des Empfaengers scheitert (`state/adresse.ts#zerlegePfad`). Die Kennung ist die lesbare der Bestellung
 * (`lib/bestellkennung.ts#kennungVon`: Bestellnummer, sonst `id`).
 *
 * Regel fuer dieses Modul (`test/lib/reineKette.test.ts`): keine Importe, nichts aus React und nichts aus dem Browser. Der Server
 * kopiert die Datei zeichengleich (`backend/scripts/ki-auswertung-kopieren.ts`).
 */

/** Die zwei Pfadteile `bestellung` und `<kennung>`, wie `schreiben` sie hinter dem Seitenkuerzel anfuegt. */
export function bestellungPfadTeile(kennung: string): [string, string] {
  return ["bestellung", encodeURIComponent(kennung)];
}

/** Die Kurzform `/bestellung/<kennung>` (§ 3.5) - der Pfad, den ein verschickter Link traegt. */
export function bestellungKurzlink(kennung: string): string {
  return `/${bestellungPfadTeile(kennung).join("/")}`;
}
